module.exports = __webpack_public_path__ + "img/role.c1dc2759.png";